<template>
    <div>
        <div class="row mb-2">
            <div class="col">
                <button v-if="gadget.disabled == false  && (claimApproved == false || isSysAdmin == true)"
                        type="button"
                        class="btn btn-danger btn-sm float-right mb-2"
                        @click="$bvModal.show(_uid + 'remove-gadget-modal')">
                    <i class="fas fa-ban"></i> Remove gadget from claim
                </button>
            </div>
        </div>
        <b-alert :show="gadget.disabled == true" variant="danger">
            <h4 class="alert-heading">Gadget has been removed from the claim!</h4>
            <p>The customer will not be able to select any repair options for this gadget.</p>
        </b-alert>
        <div class="row mb-2">
            <div class="col-sm-4">Status</div>
            <div class="col"><gadget-history :gadgetId="gadget.id" /></div>
        </div>
        <hr />
        <simple-display-grid key="simpleDisplayGrid3"
                             :columnCount="2"
                             :inputs="insuranceLineId == 1 ? gadgetDetailsInputs1 : insuranceLineId == 2 ? gadgetDetailsInputs0 : gadgetDetailsInputs5"
                             :values="gadget" />
        <simple-display-grid v-if="isADOrMB"
                             key="simpleDisplayGrid6"
                             :columnCount="2"
                             :inputs="gadgetDetailsInputs4"
                             :values="gadget" />
        <hr v-if="isTheftOrLoss" />
        <simple-display-grid v-if="isTheftOrLoss"
                             key="simpleDisplayGrid4"
                             :columnCount="2"
                             :inputs="gadgetDetailsInputs2"
                             :values="gadget" />
        <hr v-if="!gadgetPolicyholderPossession(gadget)" />
        <simple-display-grid v-if="!gadgetPolicyholderPossession(gadget)"
                             key="simpleDisplayGrid5"
                             :columnCount="2"
                             :inputs="gadgetDetailsInputs3"
                             :values="gadget" />
        <div v-if="showGadgetExcess">
            <hr />
            <claim-gadget-excess :claimId="parseInt(claimId)" :gadgetId="parseInt(gadget.id)" />
        </div>
        <b-modal :id="_uid + 'remove-gadget-modal'" hide-footer>
            <template slot="modal-title">
                Remove gadget from claim
            </template>
            <div class="d-block text-center">
                <div class="row">
                    <div class="col"><strong>Type:</strong></div>
                    <div class="col">{{gadget.typeLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Make</strong></div>
                    <div class="col">{{gadget.makeLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Model</strong></div>
                    <div class="col">{{gadget.modelLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>IMEI / Serial</strong></div>
                    <div class="col">{{gadget.imeiNo}} {{gadget.serialNo}}</div>
                </div>
            </div>
            <hr />
            <p><i class="fas fa-info"></i> This will be visible to the customer / claimant</p>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label">
                    Please provide reason
                </label>
                <div class="col-sm-8">
                    <textarea class="form-control form-control-sm"
                              placeholder="Reason for removing gadget from claim"
                              v-model="obj.reason">
                    </textarea>
                    <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !getValidatorIsValid(obj,'reason')">
                        {{getValidatorInvalidFeedback(obj,'reason')}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="float-right">
                        <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                        <button class="btn btn-success mt-3 ml-2" @click="handleSaveClick">Remove</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import GadgetHistory from '@/components/GadgetHistory.vue'
    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import ClaimGadgetExcess from '@/components/ClaimGadgetExcess.vue'
    import { gadgetDetailsInputs0, gadgetDetailsInputs1, gadgetDetailsInputs2, gadgetDetailsInputs3, gadgetDetailsInputs4, gadgetDetailsInputs5 } from '@/ui.config/inputs/gadgetDetailsInputs'
    import { required, maxLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    let initObj = {
        reason: null,
        validators: [
            {
                item: 'reason',
                validators: [
                    required,
                    maxLen(100)
                ],
                isValid: false,
                inValidFeedback: 'Required, max 100 characters (including spaces)'
            }
        ]
    }
    export default {
        name: 'GadgetDetails',
        props: {
            claimId: Number,
            incidentTypeParentId: Number,
            insuranceLineId: Number,
            gadget: Object,
            totalGadgets: Number,
            claimApproved: Boolean
        },
        components: {
            SimpleDisplayGrid,
            'claim-gadget-excess': ClaimGadgetExcess,
            'gadget-history': GadgetHistory
        },
        mixins: [
            watchAll,
            validator
        ],
        data: () => {
            return {
                gadgetDetailsInputs0: gadgetDetailsInputs0,
                gadgetDetailsInputs1: gadgetDetailsInputs1,
                gadgetDetailsInputs2: gadgetDetailsInputs2,
                gadgetDetailsInputs3: gadgetDetailsInputs3,
                gadgetDetailsInputs4: gadgetDetailsInputs4,
                gadgetDetailsInputs5: gadgetDetailsInputs5,

                attemptSave: false,
                obj: initObj
            }
        },
        mounted() {
            this.watchAll(['obj.reason'], this.objRunValidators.bind(this))
        },
        computed: {
            showGadgetExcess() {
                return (this.insuranceLineId == 1 || this.insuranceLineId == 5) && this.gadget.disabled == false
            },
            isTheftOrLoss() {
                return this.incidentTypeParentId == 1001 || this.incidentTypeParentId == 1002
            },
            isADOrMB() {
                return this.incidentTypeParentId == 1000 || this.incidentTypeParentId == 1003
            },
            isSysAdmin() {
                if (this.$adminUser) {
                    if (this.$adminUser.isSystemAdmin()) {
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            gadgetPolicyholderPossession(gadget) {
                return gadget.policyholderPossession
            },
            handleSaveClick() {
                this.attemptSave = true
                if (getValidatorsIsValid(this.obj)) {
                    this.$bvModal.hide(this._uid + 'remove-gadget-modal')
                    this.$emit('remove_clicked', { gadgetId: this.gadget.id, reason: this.obj.reason, rowVersion: this.gadget.rowVersion })
                }
            },
            handleCancelClick() {
                this.$bvModal.hide(this._uid + 'remove-gadget-modal')
                this.attemptSave = false
                this.obj.reason = null
            },
            objRunValidators() { runValidators(this.obj) },
            //objExReset() { this.objEx = Object.assign({}, initObjEx) }
        }
    }
</script>
